export interface EventoReferentFormValues {
  name: string;
  roleId: number | null;
  email: string;
  phone: string;
}

export interface EventoWizardFormValues {
  name: string;
  description: string;
  businessClientId: number | null;
  isActive: boolean;
  fromDate: string;
  toDate: string;
  referents: EventoReferentFormValues[];
}

export const emptyReferent: EventoReferentFormValues = {
  name: '',
  roleId: null,
  email: '',
  phone: ''
};

export const eventoWizardInitialValues: EventoWizardFormValues = {
  name: '',
  description: '',
  businessClientId: null,
  isActive: false,
  fromDate: '',
  toDate: '',
  referents: [{ ...emptyReferent }]
};
